import { render, staticRenderFns } from "./SkillModal.vue?vue&type=template&id=3af053bb&scoped=true"
import script from "./SkillModal.vue?vue&type=script&lang=js"
export * from "./SkillModal.vue?vue&type=script&lang=js"
import style0 from "./SkillModal.vue?vue&type=style&index=0&id=3af053bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af053bb",
  null
  
)

export default component.exports